export default {"src":"/_next/static/media/discover.9e1c25df.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};